module.exports = __webpack_public_path__ + "static/img/tkachenko.fce8a5b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tkachenko.jpg
// module id = 190
// module chunks = 1